// extracted by mini-css-extract-plugin
export default {"imageWrapper":"iP-z","hovered":"jP-z","hoverImage":"kP-z","mainImage":"lP-z","imageNoBackground":"mP-z","fullSizeImage":"nP-z"};